// Plaster / stucco recipe — Buildings Set1 §7.4: a fine fbm bump with a subtle colour drift. Used
// for `wallInterior` (plaster) and stucco exteriors. Smooth, matte, low-relief — the "troweled"
// read. Immutable built-in root.
import {MaterialLayer, MaterialRecipe, ParamSchema} from "../@MaterialTypes.js";

export const PLASTER_RECIPE_ID = "plaster";

export const plasterRecipe = new MaterialRecipe({
	id: PLASTER_RECIPE_ID,
	name: "Plaster",
	roughness: 0.7,
	specStrength: 0, // matte trowel — no highlight

	params: [
		new ParamSchema({key: "plaster_scale", label: "Base scale (m)", kind: "scalar", min: 0.1, max: 20, default: 1.2}),
		new ParamSchema({key: "plaster_ramp", label: "Plaster ramp", kind: "ramp", default: [0, 0.78, 0.74, 0.7, 0.5, 0.82, 0.78, 0.73, 1, 0.76, 0.71, 0.66]}),
		new ParamSchema({key: "bump_scale", label: "Bump scale (m)", kind: "scalar", min: 0.005, max: 0.2, default: 0.04}),
		new ParamSchema({key: "bump_height", label: "Bump relief (m)", kind: "scalar", min: 0, max: 0.01, default: 0.0012}),
	],
	layers: [
		// Base: colour only, very low contrast fbm — the subtle "was mixed in one pour" drift.
		new MaterialLayer({
			id: "base",
			primitive: "fbm",
			args: {
				scale: {ref: "plaster_scale"},
				octaves: 4,
				lacunarity: 2,
				persistence: 0.5,
				mode: 0,
				colorRamp: {ref: "plaster_ramp"},
				heightScale: 0,
			},
			blend: "over",
			contributes: "color",
		}),
		// Fine trowel bump: low-amplitude fbm relief so the surface isn't perfectly flat.
		new MaterialLayer({
			id: "bump",
			primitive: "fbm",
			args: {
				scale: {ref: "bump_scale"},
				octaves: 4,
				lacunarity: 2.2,
				persistence: 0.5,
				mode: 0,
				colorRamp: {ref: "plaster_ramp"},
				heightScale: {ref: "bump_height"},
			},
			blend: "over",
			contributes: "height",
		}),
	],
});
